// Build out some constants that will be used by the API as well as other modules to get the date through
// reflection
export const MODELPROPERTIES = "model:properties";
export const MODEL = "model:model";
export const MODELNAME = "model:name";
export const FIELD = "model:field";
export const STATICMETHOD = "model:static:method";
export const METHOD = "model:method";
export const FIELDARRAY = "model:field:array";

/**
 * Helper method that will create a list of properties that are affected by this API
 * 
 * @param target: any
 *   The target we need to add the list of properties to
 * @param propertyKey: string
 *   The property on the object we are adding to the list
 */
export function AddToModelParamList(target: any, propertyKey: string): void {
    if (!Reflect.hasMetadata(MODELPROPERTIES, target)) {
        Reflect.defineMetadata(MODELPROPERTIES, [], target);
    }

    let fieldList: string[] = Reflect.getMetadata(MODELPROPERTIES, target);
    if (fieldList.indexOf(propertyKey) === -1) {
        fieldList.push(propertyKey);
        Reflect.defineMetadata(MODELPROPERTIES, fieldList, target);
    }
}